<template>
  <!-- <script src="https://accounts.google.com/gsi/client" async></script> -->
  <div class="card mx-auto" style="width: 18rem">
    <div class="card-body zeropadding">
      <div class="card-text">
        <div class="row mt-2">
          <div class="col fw-bold">Auction42!</div>
        </div>
        <div class="row mt-2 mb-2">
          <div class="col text-muted">Follow the action, bid by bid.</div>
        </div>
        <div class="row">
          <div class="col">
            <div
              id="g_id_onload"
              data-client_id="1078399587905-tfru49nkdqa086lo0csa6n6s2b4cvdb2.apps.googleusercontent.com"
              data-context="signin"
              data-ux_mode="popup"
              data-callback="handleSignInWithGoogle"
              data-auto_prompt="true"
              data-auto_select="true"
            ></div>

            <div
              class="g_id_signin"
              data-type="standard"
              data-shape="rectangular"
              data-theme="filled_blue"
              data-text="signin_with"
              data-size="medium"
              data-logo_alignment="left"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "../../supabase/config";
import { useRouter } from "vue-router";
import { onMounted } from "vue";
import { useStore } from "@/store/index";
const store = useStore();

onMounted(() => {
  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.id = "google-auth-script";
  script.async = true;
  document.body.appendChild(script);
});
const router = useRouter();
async function handleSignInWithGoogle(response) {
  const { data, error } = await supabase.auth.signInWithIdToken({
    provider: "google",
    token: response.credential,
  });
  if (!error) {
    store.setUser({ user: data.user, user_type: "" }); //user_type is updated in HomeView component
    router.push("/home");
  }
}
window.handleSignInWithGoogle = handleSignInWithGoogle;
</script>
<style scoped>
.zeropadding {
  padding: 20px;
}
</style>
